export default __webpack_public_path__ + "static/media/Sorcerer's Armbands of the Emperor's Favor.d007a78a.jpg";